<style lang="scss" scoped>
.consult-container {
  min-height: 100vh;
  background: url('./../../assets/images/wechat-consult/main-bg.png');
  background-size: 100% auto;
  background-repeat: repeat;
  overflow: hidden;
  .content {
    width: 750px;
    height: 1432px;
    background: url('./../../assets/images/wechat-consult/de-bg.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
    overflow: hidden;
    .code-container {
      width: 532px;
      height: 532px;
      margin-top: 400px;
      margin-left: 88px;
      border: 6px solid #232323;
      box-sizing: border-box;
      .img {
        height: 100%;
        width: 100%;
      }
    }
  }
}
</style>

<template>
  <div class="consult-container">
    <div class="content">
      <div class="code-container">
        <img class="img" :src="imageUrl" alt="加载失败，刷新重试">
      </div>
    </div>
  </div>
</template>

<script>
import { fetchWechatImage } from "./../../common/api/wechat-consult";

export default {
  data () {
    return {
      imageUrl: ''
    }
  },
  created () {
    fetchWechatImage()
      .then(result => {
        if (result && result.errorCode === 0) {
          this.imageUrl = result.imageUrl;
        }
      })
  }
}
</script>
